"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailParameters = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class EmailParameters extends base_models_1.Serializable {
}
exports.EmailParameters = EmailParameters;
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'email_address' }),
    (0, class_validator_1.IsEmail)(),
    (0, base_models_1.Docs)({
        description: `customer's email address to send the email to. If no email is supplied the BPM caseId will be used to retrieve the email`,
        example: 'customer@gmail.com',
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], EmailParameters.prototype, "emailAddress", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'salutation' }),
    (0, base_models_1.Docs)({ description: 'how to greet a customer', example: 'heer' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], EmailParameters.prototype, "salutation", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'initials' }),
    (0, base_models_1.Docs)({ description: "initials to customer's first name", example: 'A.B.' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], EmailParameters.prototype, "initials", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'prefix' }),
    (0, base_models_1.Docs)({ description: "prefix to customer's last name", example: 'de' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], EmailParameters.prototype, "prefix", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'last_name' }),
    (0, base_models_1.Docs)({ description: "customer's last name", example: 'Vries' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], EmailParameters.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'case_id' }),
    (0, base_models_1.Docs)({ description: 'ID of the BPM case', example: 'abc123' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], EmailParameters.prototype, "caseId", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'account_id' }),
    (0, base_models_1.Docs)({ description: "Customer's account ID", example: '0123456789' }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], EmailParameters.prototype, "accountId", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'form_link' }),
    (0, base_models_1.Docs)({
        description: 'link to the form that customer needs to fill (enrichment form or quotation form)',
        example: 'https://mock.example.com/schouwformulier',
    }),
    (0, class_validator_1.IsUrl)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], EmailParameters.prototype, "formLink", void 0);
